import { BrowserRouter, Route, Switch } from "react-router-dom";
import React from "react";
import About from "../components/About";
import Admin from "../components/Admin";
import AdminHome from "../components/Admin/AdminHome";
import AllUsers from "../components/Admin/AllUsers";
import Avatar from "../components/Avatar";
import Chart from "../components/Chart";
import Home from "../components/Home";
import Navbar from "../components/Navbar";
import NickName from "../components/NickName";
import Prize from "../components/Prize";
import Profile from "../components/Profile";
import ProfileEdit from "../components/ProfileEdit";
import Quizpad from "../components/QuizPad";
import SelfDelete from "../components/SelfDelete";
import SignIn from "../components/SignIn";
import TestQuiz from "../components/TestQuiz";
import NotFound from "../components/NotFound";
import Challenge from "../components/Challenge";
import SelectFriends from "../components/Challenge/SelectFriends";

const AppRouter = () => (
  <BrowserRouter>
    <Navbar backdrop={true} />
    <Switch>
      <Route path="/" component={Home} exact={true} />
      <Route path="/about" component={About} exact={true} />
      <Route path="/admin_l7" component={Admin} exact={true} />
      <Route path="/admin_l7/home" component={AdminHome} exact={true} />
      <Route path="/admin_l7/users" component={AllUsers} exact={true} />
      <Route path="/avatar" component={Avatar} exact={true} />
      <Route path="/challenge" component={Challenge} exact={true} />
      <Route path="/challenge/select" component={SelectFriends} exact={true} />
      <Route path="/chart" component={Chart} exact={true} />
      <Route path="/prize" component={Prize} exact={true} />
      <Route path="/nickname" component={NickName} exact={true} />
      <Route path="/profile" component={Profile} exact={true} />
      <Route path="/profile/edit" component={ProfileEdit} exact={true} />
      <Route path="/luckygame" component={Quizpad} exact={true} />
      <Route path="/signin" component={SignIn} exact={true} />
      <Route path="/delete_user" component={SelfDelete} exact={true} />
      <Route path="/guest" component={TestQuiz} exact={true} />
      <Route component={NotFound} />
    </Switch>
  </BrowserRouter>
);

export default AppRouter;
